<template>
  <v-dialog v-model="show" persistent @keydown.esc="hide">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        small
        icon
        color="primary"
        style="margin-bottom: 1px; margin-left: 8px"
      >
        <v-icon>help_outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline lighten-2" primary-title
        >{{ $t("profile.mentorship.info.title") }} <v-spacer />
        <v-btn icon @click="hide"><v-icon>close</v-icon></v-btn>
      </v-card-title>

      <v-img
        :src="require('@/assets/mentorship/mentorshipFlow.jpg')"
        alt="mentorshipFlow.jpg"
      />

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },

  methods: {
    hide() {
      this.show = false;
    },
  },
};
</script>
